<template>
  <header
    id="site-header"
    class="site-header"
    :class="[{ active: isOpen }, { subMenuDesktop: currentSub !== -1 }]"
  >
    <div class="flex">
      <div class="upper content-max-width">

        <a href="/home" class="logo" @click.prevent="reshowBanner">
          <img src="/images/aims-logo.svg" alt="test" />
        </a>

        <div class="right flex justify-between align-center">

          <div class="search-button flex align-center">
            <img
              @click="searchActive = true"
              src="/images/icons/magnify.svg"
              alt=""
            />
            <p class="desktop">
                <a href="/contact-us" class="contact">Contact us</a>
            </p>
          </div>

          <a href="/free-visa-assessment" class="desktop button ghost">Free visa assessment</a>

          <div
            class="flex flex-col justify-between hamburger"
            :class="{ active: isOpen }"
            @click="toggleMenu"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>

        </div>
      </div>

      <div class="divider desktop"></div>

      <nav class="bottom content-max-width">
        <ul>
          <div class="divider desktop"></div>
          <li
            class="item"
            v-for="(nav, i) in navs"
            :key="i"
            @mouseenter="toggleSub(i)"
            @mouseleave="!isOpen ? currentSub = -1 : null"
            :class="[{ 'active' : currentSub === i }, { 'active' : currentMenu.id === nav.id }]"
          >
            <a
              :href="nav.url"
              class="flex align-center main-link"
            >
              {{ nav.title }}
            </a>
            <img src="/images/icons/right-main-white.svg" class="arrow" alt="AIMS" v-if="currentSub === i" @click="mobToggle(i)">
            <img src="/images/icons/right-main.svg" class="arrow" alt="AIMS" v-else  @click="mobToggle(i)">

            <!-- desktop toggle -->
            <div
              class="sub-menu-desktop tab-down"
              v-show="currentSub === i"
            >
              <header-sub-menu
                v-for="(subNav, k) in nav.subNavs"
                :key="k"
                :sub-nav="subNav"
              />
            </div>

            <!-- mobile toggle -->
            <div
              v-if="isOpen"
              class="sub-menu"
              :class="{ active: currentSub === i }"
            >
              <a :href="subNav.url" v-for="(subNav, m) in nav.subNavs" :key="m">
                {{ subNav.title }}
              </a>
            </div>

            <div v-if="isOpen" class="sub-menu-2 tab-down">
              <a
                :href="subNav2.url"
                v-for="(subNav2, n) in nav.subNavs2"
                :key="n"
                :class="nav.class"
              >
                {{ subNav2.title }}
              </a>
            </div>

          </li>
        </ul>

        <a href="/free-visa-assessment" class="mobile button ghost">Free visa assessment</a>

        <ul class="tab-up">
          <li
            v-for="(item, ind) in navs[0].subNavs2"
            :key="ind"
          >
            <a :href="item.url">
              {{ item.title }}
            </a>
          </li>
          <li
            v-for="(item, inde) in navs[1].subNavs2"
            :key="inde"
          >
            <a :href="item.url">
              {{ item.title }}
            </a>
          </li>
          <li class="contacts">
            <a href="tel:08002467456225">
              0800 Aims Global
            </a>
            <a href="mailto:info@aimsglobal.co.nz" class="mail">
              info@aimsglobal.co.nz
            </a>
          </li>
        </ul>
      </nav>
    </div>

    <SearchMenu :searches="searches" v-if="searchActive" @onCloseSearch="searchActive = false" />

  </header>
</template>

<script>
import SearchMenu from './SearchMenu'
import HeaderSubMenu from './HeaderSubMenu'

export default {
  props: ["csrf", "data", "logged_in", "searches"],

  components: {
    SearchMenu,
    HeaderSubMenu,
  },

  data () {
    return {
      currentSub: -1,
      currentMenu: {},
      isOpen: false,
      isOpenDesktop: false,
      isOpenMobile: false,
      searchActive: false,
      navs: [
        {
          id: 0,
          title: "For individuals",
          url: '/statics/for-individuals',
          subNavs: [
            { title: 'Work visas', url: '/statics/work-visas' },
            { title: 'Student visas', url: '/statics/student-visas' },
            { title: 'Resident visas', url: '/statics/resident-visas' },
            { title: 'Family visas', url: '/statics/family-visas' },
            { title: 'Visitor visas', url: '/statics/visitor-visas' },
            { title: 'Business & investor visas', url: '/statics/business-investor-visas' },
            { title: 'Immigration complications', url: '/statics/immigration-complications' }
          ],
          subNavs2: [
            { title:"PLANNING YOUR TRIP", url: '#'},
            { title:"LIVING IN NEW ZEALAND", url: '#'},
            { title:"IMMIGRATION NEWS", url: '#'},
            { title:"ABOUT US", url: '#'}
          ],
        },
        {
          id: 1,
          title: "Employ migrants",
          url: '/statics/employ-migrants',
          subNavs: [
            { title: 'For employers', url: '/statics/for-employers',
              children: [
                { title: 'Employee Visas', url: '/statics/employee-visas' },
                { title: 'Get accreditation', url: '/statics/get-accreditation' },
                { title: 'Become a partner', url: '/statics/become-a-partner' }
              ]
            },
            { title: 'For recruiters', url: '/statics/for-recruiters' },
          ],

          subNavs2: [
            { title:"OUR PEOPLE", url: '#'},
            { title:"TERMS & CONDITIONS", url: '#'},
            { title:"PRIVACY POLICY", url: '#'},
            { title:"CONTACT US", url: '#'}
          ],
        },
        {
          id: 2,
          title: "For educators",
          url: '/statics/for-educators',
          subNavs: [
            { title: 'International students', url: '/statics/international-students' },
            { title: 'Education partners', url: '/statics/education-partners' },
            { title: 'Support visas for your staff', url: '/statics/support-visas-for-your-staff' }
          ],
        },
        {
          id: 3,
          title: "Border exemptions",
          url: "/statics/border-exemptions",
          subNavs: [
            { title: 'For employers', url: '/statics/border-exemptions-for-employers' },
            { title: 'For individuals', url: '/statics/border-exemptions-for-individuals' }
          ],
          subNavs2: [
            { title:"0800 Aims Global", url: '#'},
            { title:"09 919 1930", url: '#'},
            { title:"+ 64 21 257 5250", url: '#'},
            { title:"info@aimsglobal.co.nz", url: '#'}
          ],
          class: "last",
        }
      ]
    };
  },

  mounted () {
    //   FE to check. not working properly
    // this.currentMenu = this.data.find(obj => obj.url === window.location.pathname)
    this.navs = this.data
  },

  methods: {
    reshowBanner () {
      window.sessionStorage.removeItem('dismissed-banner')
      window.location.href = '/home'
    },

    toggleMenu () {
      const body = document.querySelector("body");
      body.classList.toggle("overflow-hidden");
      this.isOpen = !this.isOpen;

        if (document.body.style.overflow == 'hidden') {
            document.body.style.overflow = "scroll";
        }
        else {
            document.body.style.overflow = "hidden"
        }
    },

    mobToggle (navIndex) {
      let width = window.innerWidth
      if (this.isOpen && width > 1024) {
        return
      }
      console.log('das')
      if (navIndex !== this.currentSub) {
        this.$parent.isFixed = true
        this.isOpenMobile = !this.isOpenMobile
        return (this.currentSub = navIndex)
      }
      this.$parent.isFixed = false
      return (this.currentSub = -1)
    },

    toggleSub (navIndex) {
      // don't do anything if isOpen
      if (this.isOpen) {
        return
      }

      if (navIndex !== this.currentSub) {
        this.isOpenDesktop = !this.isOpenDesktop
        return (this.currentSub = navIndex)
      }
      return (this.currentSub = -1)
    },

    logout () {
      window.axios
        .post("/logout", { token: this.csrf })
        .then((response) => {
          window.location.href = "/";
        })
        .catch((error) => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue